var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0358 21.1509C25.1175 24.055 20.9383 24.9475 17.2692 23.8L10.5967 30.4584C10.115 30.9542 9.16583 31.2517 8.48583 31.1525L5.3975 30.7275C4.3775 30.5859 3.42833 29.6225 3.2725 28.6025L2.8475 25.5142C2.74833 24.8342 3.07417 23.885 3.54167 23.4034L10.2 16.745C9.06667 13.0617 9.945 8.88254 12.8633 5.97837C17.0425 1.7992 23.8283 1.7992 28.0217 5.97837C32.215 10.1575 32.215 16.9717 28.0358 21.1509Z",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76083 24.7775L13.0192 28.0358",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5417 15.5834C21.7153 15.5834 22.6667 14.632 22.6667 13.4584C22.6667 12.2848 21.7153 11.3334 20.5417 11.3334C19.3681 11.3334 18.4167 12.2848 18.4167 13.4584C18.4167 14.632 19.3681 15.5834 20.5417 15.5834Z",
    stroke: "#3C8DBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.2089e9bacaaf453936fa00b77943c0dc.svg";
export { ForwardRef as ReactComponent };